import React from 'react';
import ActionButton from '../../action-button';

const PublishButton = ({ label, onClick, isCompact }) => {
  const iconProps = isCompact
    ? {
        iconGlyph: 'publish',
        iconPlacement: 'after',
      }
    : {};

  return (
    <ActionButton
      appearance="accent"
      format="solid"
      // @ts-ignore TS(2322): Type 'string | null' is not assignable to type 'nu... Remove this comment to see the full error message
      label={isCompact ? null : label}
      onClick={onClick}
      size="small"
      {...iconProps}
    />
  );
};

export default PublishButton;
